import { useEffect, useCallback } from 'react';
/**
 * Хук, который вызывает коллбэк на `mousedown` за пределами элемента из рефа.
 */
export function useOutsideClick(ref, onClick) {
    const handleClickOutside = useCallback((event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            onClick(event);
        }
    }, [onClick, ref]);
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);
}
